import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class PrivilegeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (PrivilegeModel._instance == null) PrivilegeModel._instance = new PrivilegeModel(authManager);
        return PrivilegeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/privileges', 'core/privileges/codelist');

        this.entityName = 'core.Privilege';
        this.privileges = {
            create: [["adminUsers"]],
            read: [["#everyone"]],
            update: [["adminUsers"]],
            delete: [["adminUsers"]],
        };

        this.label = 'Privilege';
        this.setLabel = 'Privileges';

        this.browser = {
            name: 'default-core-privilege-browser',
            moduleName: 'default-core-privilege-browser',
            moduleTitle: 'Privileges',
            moduleStateSlotName: 'default-core-privilege-browser',
        };

        this.editor = {
            name: 'default-core-privilege-editor',
            moduleName: 'default-core-privilege-editor',
            moduleTitle: 'Privilege',
            moduleStateSlotName: 'default-core-privilege-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
